module.exports = __webpack_public_path__ + "img/pasl.6cf387e4.svg";